module.exports = __webpack_public_path__ + "img/United-Kingdom.6bd9a798.png";